module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_p"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Bio_Text"
  }, [_vm._v("Nicola Casimir has a talent for finding trouble, or rather, it finds her. Six months after most of downtown Austin was leveled, her new case with the sexy federal agent assigned as her handler pits her back up against the shadowy forces that almost killed her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Bio_Text"
  }, [_vm._v("There's no hiding the sparks between them as they navigate their evolving relationship. Old adversaries become new allies. New enemies are unimaginally powerful, and both of them will learn that nothing burns as hot as someone who has nothing to lose.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Paragraph"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 63
// module chunks = 0